import * as React from 'react';
import { IPanelProps, Panel } from 'core/decorators/Panel';
import { Form, Input } from "decorator-form";
import InputType from "../../common/form/InputType";

@Form({title: "Audio Player Panel Config"})
export default class TextPanelConfig {
	@Input({type: InputType.TEXT, title: "Audio file url"})
	public url: string;
}

@Panel({id: "audioPlayer", configClass: TextPanelConfig})
export class TextPanel extends React.PureComponent<IPanelProps<TextPanelConfig>> {

	public render() {
		const { url } = this.props.config;

		return (
			<audio controls src={url}>
				Your browser does not support the audio element.
			</audio>
		);
	}
}



// WEBPACK FOOTER //
// ./src/panels/audioPlayer/AudioPlayer.panel.tsx